'use client'

import { Box, Slider, Typography } from '@mui/material'

// Types
import type { CalculatorFieldProps } from '@/types/components/molecules/home'

// Labeled slider with its current value shown on the side
const CalculatorFieldMolecule = (props: CalculatorFieldProps) => {
	// Props
	const { label, valueText, value, min, max, step, onChange } = props

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 2 }}>
				<Typography sx={{ fontSize: 15, color: 'grey.700' }}>{label}</Typography>

				<Typography sx={{ fontSize: 18, fontWeight: 700, color: 'primary.dark', whiteSpace: 'nowrap' }}>{valueText}</Typography>
			</Box>

			<Slider
				value={value}
				min={min}
				max={max}
				step={step}
				onChange={(_, next) => onChange(next as number)}
				aria-label={label}
				sx={{ mt: 1, height: 6, '& .MuiSlider-thumb': { width: 22, height: 22, boxShadow: '0 4px 12px rgba(0, 156, 156, 0.35)' } }}
			/>
		</Box>
	)
}

export default CalculatorFieldMolecule
